<script lang="ts">
    import Button from '../components/button.svelte';
    import { appState } from '../stores';
    import {fade, slide} from 'svelte/transition';
    import BrandButton from './brand-button.svelte';
    import Backdrop from '../components/backdrop.svelte';

    export let active:boolean = false;

    function manageAppState(area:number) {
        $appState.view = area;
    }
</script>

{#if active}
    <Backdrop />
    <nav class:active="{active}" transition:slide={{ delay: 0, duration: 150, axis: 'x' }}>
        <div class="drawer-contents">
            <div class="nav-header">
                <div class="logo-area">
                    <BrandButton large />
                </div>
                <div>
                    <Button
                        label=""
                        icon="x"
                        handleClick={() => manageAppState(0)}
                        role="tertiary"
                        roundedCorners={false}
                    />
                </div>
            </div>
            <ul>
                <li><Button
                    label="Colors"
                    role="tertiary" 
                    handleClick={() => manageAppState(0)}
                    icon="rainbow"
                    roundedCorners={false}
                    iconLeft
                /></li>
                <li><Button
                    label="Export"
                    role="tertiary" 
                    handleClick={() => manageAppState(2)}
                    icon="code"
                    roundedCorners={false}
                    iconLeft
                /></li>
                <li><Button
                    label="About"
                    role="tertiary" 
                    handleClick={() => manageAppState(3)}
                    icon="info"
                    roundedCorners={false}
                    iconLeft
                /></li>
                <li><Button
                    label="Settings"
                    role="tertiary" 
                    handleClick={() => manageAppState(4)}
                    icon="settings"
                    roundedCorners={false}
                    iconLeft
                /></li>
            </ul>
        </div>
    </nav>
{/if}

<style>
    nav {
        background-color: var(--background);
        position: absolute;
        z-index: 6;
        left: 0;
        top: 0;
        height: 100vh;
        max-width: 0;
        border-right: 1px solid var(--background-offset);
        overflow: hidden;
    }
    nav.active {
        max-width: fit-content;
    }
    .drawer-contents {
        min-width: 300px;
    }
    .nav-header {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
    ul {
        list-style-type: none;
        padding: 0;
        display: grid;
    }
    li {
        display: grid;
    }
    li:first-child {
        padding: 1rem 0;
        border-top: 1px solid var(--background-offset);
        border-bottom: 1px solid var(--background-offset);
        margin-bottom: 1rem;
    }
    .logo-area {
        padding: 2rem 1rem;
    }
</style>